module.exports = __webpack_public_path__ + "img/logo_raptors_mou.d85ea3f2.jpg";